import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'

//import layout
import FrontendLayout from '@/layouts/Frontend.vue'
import BackendLayout from '@/layouts/Backend.vue'

//import views
//frontend
import Home from '@/views/frontend/Home.vue'
import Login from '@/views/backend/Login.vue'
import NotFound from '@/views/frontend/NotFound404.vue'
import Register from '@/views/frontend/Register'
import Cookies from 'js-cookie'

function authGuard(to, from, next) {

  let isAuthenticated = false
  if (store.getters['authMember/logedIn']) {
    if (to.meta.roles) {
      let roles = localStorage.getItem('ccur');
      let roleAllowed = roles.includes(to.meta.roles) //ตรวจสอบว่ามีสิทธ์เข้าถึงหน้่าที่ต้องการไหม
      if (roleAllowed) {
        if (to.meta.permissions) {
          let permissions = localStorage.getItem('ccups')
          let permissionAllowed = permissions.includes(to.meta.permissions)
          if (!permissionAllowed) {
            router.push({
              name: 'NotFound' //ถ้าไม่มีสิทธ์ให้แสดงว่าไม่พบหน้าที่ต้องการ
            })
          }
        }
        // refresh expired token
        // store.dispatch('authMember/refreshExpiredToken')
        //   .then(() => {

        //   })
        //   .catch(error => {
        //     if(error.response.status == 401){ //ถ้า token หมดอายุ
        //       localStorage.removeItem('ccan')
        //       localStorage.removeItem('ccups')
        //       localStorage.removeItem('ccur')
        //       store.dispatch('authMember/unauthenticateResetting')
        //       router.push({name: 'Login'})
        //       console.log('unauthenticate')
        //     }
        //   })
      } else {
        router.push({
          name: 'NotFound' //ถ้าไม่มีสิทธ์ให้แสดงว่าไม่พบหน้าที่ต้องการ
        })
      }
    }
    isAuthenticated = true
  } else {
    isAuthenticated = false
  }

  if (isAuthenticated) {
    next() //อนุญาติให้เข้าสู่ route และโหลด component ที่ต้องการได้
  } else {
    next({ name: 'Login' })
  }
}

const routes = [
  //------------------------------Frontend section----------------------------------
  //------------------------------Flood relief mission (misi bantu banjir)----------
  {
    path: '/bantubanjirform',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'FloodReliefMissionForm',
        component: require('@/views/frontend/floodReliefMission/Form').default,
        beforeEnter: authGuard,
      }
    ],
    meta: {
      title: 'ภารกิจช่วยเหลือผู้ประสบภัยน้ำท่วม',
      // description: 'ยืนยันการโอนเงิน'  
    }
  },
  {
    path: '/bantubanjiredit/:encryptedId',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'FloodReliefMissionEdit',
        component: require('@/views/frontend/floodReliefMission/Edit').default,
        beforeEnter: authGuard,
      }
    ],
    meta: {
      title: 'แก้ไขคำขอเบิกค่าเชื้อเพลิง',
    }
  },
  {
    path: '/bantubanjir',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'FloodReliefMission',
        component: require('@/views/frontend/floodReliefMission/Index').default,
        // beforeEnter: authGuard,
      }
    ],
    meta: {
      title: 'ภารกิจช่วยเหลือผู้ประสบภัยน้ำท่วม',
      // description: 'ยืนยันการโอนเงิน'  
    }
  },
  {
    path: '/bantubanjirstatus',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'FloodReliefMissionStatus',
        component: require('@/views/frontend/floodReliefMission/Status').default,
        beforeEnter: authGuard,
      }
    ],
    meta: {
      title: 'ภารกิจช่วยเหลือผู้ประสบภัยน้ำท่วม',
      // description: 'ยืนยันการโอนเงิน'  
    }
  },
  {
    path: '/bantubanjircheck',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'FloodReliefMissionPublicStatus',
        component: require('@/views/frontend/floodReliefMission/PublicStatus').default,
        // No authGuard - public access
      }
    ],
    meta: {
      title: 'ตรวจสอบสถานะคำขอ - ภารกิจช่วยเหลือผู้ประสบภัยน้ำท่วม',
    }
  },
  {
    path: '/applyopenpbp2024',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'ApplyOpenPbb',
        component: require('@/views/frontend/apply/ApplyOpenPbb').default,
      }
    ],
    meta: {
      title: 'สมัครโครงการสาธารณะประโยชน์',
      // description: 'ยืนยันการโอนเงิน'  
    }
  },
  {
    path: '/cartQrPromptpayNoAuth/:order_id_code/:unmember_id_code',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'CartQrPromptpayWithoutLogin',
        component: require('@/views/frontend/cart/QrPromptpay').default,
      }
    ],
    meta: {
      title: 'ชำระเงิน',
      roles: ['$2y$10$nOt5dwhzLifPrx.GYk5V7eANvPiiTJdPC9j5gLoqIwE38TY7wJsbO']
    }
  },
  {
    path: '/cartQrPromptpay/:order_id_code',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'CartQrPromptpay',
        component: require('@/views/frontend/cart/QrPromptpay').default,
        beforeEnter: authGuard,
      }
    ],
    meta: {
      title: 'ชำระเงิน',
      roles: ['$2y$10$nOt5dwhzLifPrx.GYk5V7eANvPiiTJdPC9j5gLoqIwE38TY7wJsbO']
    }
  },
  {
    path: '/donateQrPromptpay/:order_id',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'DonateQrPromptpay',
        component: require('@/views/frontend/donate/QrPromptpay').default,
        beforeEnter: authGuard,
      }
    ],
    meta: {
      title: 'ชำระเงิน',
      roles: ['$2y$10$nOt5dwhzLifPrx.GYk5V7eANvPiiTJdPC9j5gLoqIwE38TY7wJsbO']
    }
  },
  {
    path: '/design',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'Design',
        component: require('@/views/frontend/design/Organization').default
      }
    ],
    meta: {
      title: 'แก้ไขข้อมูลองค์กร'
    }
  },
  {
    path: '/lineLogin',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'LineLogin',
        component: require('@/views/frontend/account/LineLogin').default,
      }
    ],
    meta: {
      title: 'Line Login'
    }
  },
  {
    path: '/voucherManage/:organization_id',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'VoucherManage',
        component: require('@/views/frontend/account/VoucherManage').default,
        beforeEnter: authGuard,
      }
    ],
    meta: {
      title: 'จัดการข้อมูลบัตรกำนัล'
    }
  },
  {
    path: '/giftVoucher',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'GiftVoucher',
        component: require('@/views/frontend/account/GiftVoucher').default,
        beforeEnter: authGuard,
      }
    ],
    meta: {
      title: 'บัตรกำนัล'
    }
  },
  {
    path: '/amlPolicy',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'AmlPolicy',
        component: require('@/views/frontend/AmlPolicy.vue').default
      }
    ],
    meta: {
      title: 'นโยบายคุ้มครองข้อมูลส่วนบุคคล'
    }
  },
  {
    path: '/privacy',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'Privacy',
        component: require('@/views/frontend/Privacy').default
      }
    ],
    meta: {
      title: 'นโยบายคุ้มครองข้อมูลส่วนบุคคล'
    }
  },
  {
    path: '/refund',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'Refund',
        component: require('@/views/frontend/Refund').default
      }
    ],
    meta: {
      title: 'นโยบายการคืนเงิน'
    }
  },
  {
    path: '/ribaConfirmation/:order_id',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'RibaConfirmation',
        component: require('@/views/frontend/riba/Confirmation').default,
        // beforeEnter: authGuard,
      }
    ],
    meta: {
      title: 'ยืนยันการสะสางดกเบี้ย'
    }
  },
  {
    path: '/ribaQrPromptpay/:order_id',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'RibaQrPromptpay',
        component: require('@/views/frontend/riba/QrPromtpay').default,
        beforeEnter: authGuard,
      }
    ],
    meta: {
      title: 'คิวอาร์โค้ดสะสางดอกเบี้ยน'
    }
  },
  {
    path: '/ribaOrderDetail',
    component: FrontendLayout,
    children: [
      {
        path: 'RibaOrderDetail/:order_id',
        name: 'RibaOrderDetail',
        component: require('@/views/frontend/account/RibaOrderDetail').default,
        beforeEnter: authGuard,
      }
    ],
    meta: {
      title: 'รายละเอียดการสะสางดอกเบี้ย'
    }
  },
  {
    path: '/zakatOrderDetail',
    component: FrontendLayout,
    children: [
      {
        path: 'ZakatOrderDetail/:order_id',
        name: 'ZakatOrderDetail',
        component: require('@/views/frontend/account/ZakatOrderDetail').default,
        beforeEnter: authGuard,
      }
    ],
    meta: {
      title: 'รายละเอียดการจ่ายซะกาต'
    }
  },
  {
    path: '/donateOrderDetail/:order_id',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'DonateOrderDetail',
        component: require('@/views/frontend/account/DonateOrderDetail').default,
        beforeEnter: authGuard,
      }
    ],
    meta: {
      title: 'รายละเอียดการบริจาค'
    }
  },
  {
    path: '/zakatRecheckout',
    component: FrontendLayout,
    children: [
      {
        path: 'ZakatRecheckout/:order_id',
        name: 'ZakatRecheckout',
        component: require('@/views/frontend/zakat/ZakatRecheckout').default,
        beforeEnter: authGuard,
      }
    ],
    meta: {
      title: 'ยืนยันจ่ายซากาต'
    }
  },
  {
    path: '/zakatHistory',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'ZakatHistory',
        component: require('@/views/frontend/account/ZakatHistory').default,
        beforeEnter: authGuard,
      }
    ],
    meta: {
      title: 'ประวัติจ่ายซากาต'
    }
  },
  {
    path: '/zakatRecheckout',
    component: FrontendLayout,
    children: [
      {
        path: 'ZakatRecheckout/:order_id',
        name: 'ZakatRecheckout',
        component: require('@/views/frontend/zakat/ZakatRecheckout').default,
        beforeEnter: authGuard,
      }
    ],
    meta: {
      title: 'ยืนยันการโอนเงินซากาต'
    }
  },
  {
    path: '/zakatConfirmaion/:order_id',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'ZakatConfirmation',
        component: require('@/views/frontend/zakat/Confirmation').default,
        beforeEnter: authGuard,
      }
    ],
    meta: {
      title: 'ยืนยันการจ่ายซากาต'
    }
  },
  {
    path: '/ezakat',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'Zakat',
        component: require('@/views/frontend/zakat/Index').default,
      }
    ],
    meta: {
      title: 'จ่ายซะกาต'
    }
  },
  {
    path: '/checoutAgain/:order_id',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'CheckoutAgain',
        component: require('@/views/frontend/cart/CheckoutAgain').default
      }
    ],
    meta: {
      title: 'แก้ไขข้อมูลองค์กร'
    }
  },
  {
    path: '/ribaRecheckout/:order_id',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'RibaRecheckout',
        component: require('@/views/frontend/riba/RibaRecheckout').default,
        // beforeEnter: authGuard,
      }
    ],
    meta: {
      title: 'ยืนยันการโอนเงิน'
    }
  },
  {
    path: '/ribaHistory',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'RibaHistory',
        component: require('@/views/frontend/account/RibaHistory').default,
        beforeEnter: authGuard,
      }
    ],
    meta: {
      title: 'ประวัติการสะสางดอกเบี้ย'
    }
  },
  {
    path: '/donateHistory',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'DonateHistory',
        component: require('@/views/frontend/account/DonateHistory').default,
        beforeEnter: authGuard,
      }
    ],
    meta: {
      title: 'ประวัติการบริจาค'
    }
  },
  {
    path: '/crowdfunding/:id',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'ProjectDetail',
        component: require('@/views/frontend/donate/ProjectDetail').default,
        // beforeEnter: authGuard,
      }
    ],
    meta: {
      title: 'รายละเอียดโครงการ'
    }
  },
  {
    path: '/bankingTransaction',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'BankingTransaction',
        component: require('@/views/frontend/cart/BankingTransaction').default,
        beforeEach: authGuard
      }
    ],
    meta: {
      title: 'แก้ไขข้อมูลองค์กร'
    }
  },
  {
    path: '/cart',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'Cart',
        component: require('@/views/frontend/cart/Cart').default,
        // beforeEach: authGuard
      }
    ],
    meta: {
      title: 'ตะกร้า'
    }
  },
  {
    path: '/organizationProfile',
    component: FrontendLayout,
    children: [
      {
        path: 'OrganizationProfile/:id',
        name: 'OrganizationProfile',
        component: require('@/views/frontend/account/OrganizationProfile').default,
        beforeEach: authGuard
      }
    ],
    meta: {
      title: 'แก้ไขข้อมูลองค์กร'
    }
  },
  {
    path: '/createOrganization',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'CreateOrganization',
        component: require('@/views/frontend/account/CreateOrganization').default,
        beforeEach: authGuard
      }
    ],
    meta: {
      title: 'เพิ่มลองค์กร'
    }
  },
  {
    path: '/oganizationManagement',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'OrganizationManagement',
        component: require('@/views/frontend/account/OrganizationManagement').default,
        beforeEach: authGuard
      }
    ],
    meta: {
      title: 'จัดการข้อมูลองค์กร'
    }
  },
  {
    path: '/accountSetting',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'AccountSetting',
        component: require('@/views/frontend/account/AccountSetting').default,
        beforeEach: authGuard
      }
    ],
    meta: {
      title: 'ตั้งค่าบัญชี'
    }
  },
  {
    path: '/profile',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'Profile',
        component: require('@/views/frontend/account/Profile').default,
        beforeEach: authGuard
      }
    ],
    meta: {
      title: 'โปรไฟล์'
    }
  },
  {
    path: '/transasctionDetail/:transaction_id',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'TransactionDetail',
        component: require('@/views/frontend/account/TransactionDetail').default,
        beforeEach: authGuard
      }
    ],
    meta: {
      title: 'รายละเอียดการชำระเงิน'
    }
  },
  {
    path: '/paymentHistories',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'PaymentHistories',
        component: require('@/views/frontend/account/PaymentHistories').default,
        beforeEach: authGuard
      }
    ],
    meta: {
      title: 'ประวัติการชำระเงิน'
    }
  },
  {
    path: '/donateHistories',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'DonateHistories',
        component: require('@/views/frontend/donate/Histories').default,
        beforeEach: authGuard
      }
    ],
    meta: {
      title: 'ประวัติบริจาค'
    }
  },
  {
    path: '/donateCheckout/:id',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'DonateCheckout',
        component: require('@/views/frontend/donate/DonateCheckout').default
      },
    ],
    meta: {
      title: 'ยืนยันการบริจาค'
    }
  },
  {
    path: '/projectDonate/:id',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'ProjectDonate',
        component: require('@/views/frontend/donate/ProjectDonate').default,
      }
    ],
    meta: {
      title: 'ระดมทุน'
    }
  },
  {
    path: '/riba',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'Riba',
        component: require('@/views/frontend/riba/Index').default,
      }
    ],
    meta: {
      title: 'สะสางดอกเบี้ย'
    }
  },
  {
    path: '/resetPassword',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: "ResetPassword",
        component: require('@/views/frontend/account/ResetPassword').default,
        beforeEach: authGuard
      }
    ],
    meta: {
      title: 'รีเซ็ตรหัสผ่าน'
    }
  },
  {
    path: '/forgotPassword',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: "ForgotPassword",
        component: require('@/views/frontend/account/ForgotPassword').default,
        beforeEach: authGuard
      }
    ],
    meta: {
      title: 'ลืมรหัสผ่าน'
    }
  },
  {
    path: '/emailVerification',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'EmailVerification',
        component: require('@/views/frontend/account/EmailVerification').default,
        beforeEach: authGuard,
      }
    ],
    meta: {
      title: 'ยืนยันอีเมล'
    }
  },
  {
    path: '/cleanupHistory',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'CleanupHistory',
        component: require('@/views/frontend/account/CleanupHistory').default,
        beforeEnter: authGuard,
      }
    ],
    meta: {
      title: 'ประวัติการสะสาง',
      roles: ['$2y$10$nOt5dwhzLifPrx.GYk5V7eANvPiiTJdPC9j5gLoqIwE38TY7wJsbO']
    }
  },
  {
    path: '/account',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'Account',
        component: require('@/views/frontend/account/Account').default,
        beforeEnter: authGuard,
      }
    ],
    meta: {
      title: 'บัญชี',
      // :permissions ["member-verified"],
      roles: ['$2y$10$nOt5dwhzLifPrx.GYk5V7eANvPiiTJdPC9j5gLoqIwE38TY7wJsbO'],
      beforeEnter: authGuard,
      // requiresAuth: true
    }
  },
  {
    path: '/contactMe',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'ContactMe',
        component: require('@/views/frontend/Contact').default
      }
    ],
    meta: {
      title: 'ติดต่อเรา',
      // description: 'ยืนยันการโอนเงิน'  
    }
  },
  {
    path: '/article',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'Article',
        component: require('@/views/frontend/Article').default
      }
    ],
    meta: {
      title: 'วีดีโอความรู้',
      // description: 'ยืนยันการโอนเงิน'  
    }
  },
  {
    path: '/vdo',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'Vdo',
        component: require('@/views/frontend/Vdo').default
      }
    ],
    meta: {
      title: 'การเงินในอิสลาม',
      // description: 'ยืนยันการโอนเงิน'  
    }
  },
  {
    path: '/literacy',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'Literacy',
        component: require('@/views/frontend/Literacy').default
      }
    ],
    meta: {
      title: 'ความรู้',
      // description: 'ยืนยันการโอนเงิน'  
    }
  },
  //------------------------------open data------
  {
    path: '/openData',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'OpenData',
        // component: require('@/views/frontend/OpenData').default
        component: require('@/views/frontend/opendata/OpenData').default
      }
    ],
    meta: {
      title: 'Open data',
      // description: 'ยืนยันการโอนเงิน'  
    }
  },
  {
    path: '/openDataRibaMain',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'OpenDataRibaMain',
        component: require('@/views/frontend/opendata/riba/Riba').default,
      }
    ],
    meta: {
      title: 'OpenData - สะสางดอกเบี้ย',
    }
  },
  {
    path: '/openDataRibaStat',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'OpenDataRibaStat',
        component: require('@/views/frontend/opendata/riba/Stat').default,
      },
    ],
    meta: {
      title: 'OpenData - สะสางดอกเบี้ย',
    }
  },
  {
    path: '/openDataRibaBarChartYear',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'OpenDataRibaBarChartYear',
        component: require('@/views/frontend/opendata/riba/BarChartYear').default,
      }
    ],
    meta: {
      title: 'OpenData - สะสางดอกเบี้ย',
    }
  },
  {
    path: '/openDataRibaBarChartMonth',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'OpenDataRibaBarChartMonth',
        component: require('@/views/frontend/opendata/riba/BarChartMonth').default,
      }
    ],
    meta: {
      title: 'OpenData - สะสางดอกเบี้ย',
    }
  },
  {
    path: '/openDataRibaLineChartMonth',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'OpenDataRibaLineChartMonth',
        component: require('@/views/frontend/opendata/riba/LineChartMonth').default,
      }
    ],
    meta: {
      title: 'OpenData - สะสางดอกเบี้ย',
    }
  },
  {
    path: '/openDataRiba',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'OpenDataRibaReport',
        component: require('@/views/frontend/opendata/riba/RibaReport').default,
      },
    ],
    meta: {
      title: 'open data สะสางดอกเบี้ย',
      description: 'เปิดเภยข้อมูลการสะสางดอกเบี้ย'
    }
  },


  {
    // path: '/donate',
    path: '/crowdfunding',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'Donate',
        component: require('@/views/frontend/donate/Donate').default
        // component: require('@/views/frontend/Donate').default
      }
    ],
    meta: {
      title: 'ระดมทุน',
      // description: 'ยืนยันการโอนเงิน'  
    }
  },
  {
    path: '/projects',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'Projects',
        component: require('@/views/frontend/Project').default
      }
    ],
    meta: {
      title: 'โครงการ',
      // description: 'ยืนยันการโอนเงิน'  
    }
  },
  {
    path: '/about',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'About',
        component: require('@/views/frontend/About').default
      }
    ],
    meta: {
      title: 'เกี่ยวกับเรา',
      // description: 'ยืนยันการโอนเงิน'  
    }
  },
  {
    path: '/cleanupConfirming',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'CleanupConfirming',
        component: require('@/views/frontend/riba/CleanupConfirming').default,
      }
    ],
    meta: {
      title: 'ยืนยันการโอนเงิน',
      description: 'ยืนยันการโอนเงิน'
    }
  },
  {
    path: '/qrCleanup',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'QrCleanup',
        component: require('@/views/frontend/riba/Qrpayment').default,
      }
    ],
    meta: {
      title: 'โอนเงินด้วย qr code',
      description: 'โอนเงินด้วย qr code'
    }
  },
  {
    path: '/cleanupDetail',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'CleanupDetail',
        component: require('@/views/frontend/CleanupDetail').default,
      },
    ],
    meta: {
      title: 'ยืนยันสะสางดอกเบี้ย',
      description: 'ยืนยันสะสางดอกเบี้ย'
    }
  },

  // {
  //   path: '/cleanupFor/:type',
  //   component: FrontendLayout,
  //   children: [
  //     {
  //       path: '',
  //       name: 'CleanupFor',
  //       component: require('@/views/frontend/CleanupFor').default,
  //     },
  //   ],
  //   meta: {
  //     title: 'สะสางดอกเบี้ย',
  //     description: 'สะสางดอกเบี้ย'
  //   }
  // },
  {
    path: '/cleanupType',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'CleanupType',
        component: require('@/views/frontend/CleanupType').default,
      },
    ],
    meta: {
      title: 'เลือกรูปแบบการสะสางดอกเบี้ย',
      description: 'เลือกรูปแบบการสะสางดอกเบี้ย'
    }
  },
  {
    path: '/cleanup',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'Cleanup',
        component: require('@/views/frontend/Cleanup').default,
      },
    ],
    meta: {
      title: 'สะสางดอกเบี้ย',
      description: 'สะสางดอกเบี้ย'
    }
  },
  {
    path: '/',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'Home',
        component: Home,
        // beforeEnter: authGuard
      }
    ],
    meta: {
      title: "cuci platform : แพลตฟอร์มสาธารณะเพื่อสร้งสรรค์สังคม | บริจาค - ซะกาต - สะสางดอกเบี้ย",
      // description: "หน้าหลักระบบคงคลังสินค้า"
      isBackend: false
    }
  },
  {
    path: '/home',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'Homepage',
        component: Home,
        // beforeEnter: authGuard
      }
    ],
    meta: {
      title: "cuci platform : แพลตฟอร์มสาธารณะเพื่อสร้งสรรค์สังคม | บริจาค - ซะกาต - สะสางดอกเบี้ย",
      // description: "หน้าหลักระบบคงคลังสินค้า"
    }
  },
  {
    path: '/logout',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'Logout',
        component: require('@/views/frontend/Logout').default,
      }
    ],
    meta: {
      title: 'ออกจากระบบ',
      description: 'ออกจากระบบ',
    }
  },
  {
    path: '/login',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'Login',
        component: require('@/views/frontend/Login').default,
      }
    ],
    meta: {
      title: 'เข้าสู่ระบบ',
      description: 'เข้าสู่ระบบ',
      requiresVisitor: true
    }
  },
  {
    path: '/register',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'Register',
        component: Register,
      }
    ],
    meta: {
      title: 'สมัครสมาชิก',
      description: 'สมัครสมาชิก',
      requiresVisitor: true
    }
  },
  //----------------------------------Backend section-------------------------------
  //flood relief mission admin (misi bantu banjir admin)
  {
    path: '/dashboard',
    component: BackendLayout,
    children: [
      {
        path: 'floodReliefFuelRequests',
        name: 'FloodReliefFuelRequests',
        component: require('@/views/backend/floodRelief/FuelRequests').default,
        beforeEnter: authGuard
      }
    ],
    meta: {
      title: 'คำขอเบิกค่าเชื้อเพลิง',
      permissions: ['flood relief mission'],
      isBackend: true,
    }
  },
  {
    path: '/dashboard',
    component: BackendLayout,
    children: [
      {
        path: 'floodReliefFuelRequests/:id',
        name: 'FloodReliefFuelRequestManage',
        component: require('@/views/backend/floodRelief/FuelRequestManage').default,
        beforeEnter: authGuard
      }
    ],
    meta: {
      title: 'จัดการคำขอเบิกค่าเชื้อเพลิง',
      permissions: ['flood relief mission'],
      isBackend: true,
    }
  },

  //authentication admin
  {
    path: '/loginAdmin',
    component: FrontendLayout,
    children: [
      {
        path: '',
        name: 'LoginAdmin',
        component: Login,
      }
    ],
    meta: {
      title: "เกี่ยวกับเรา",
      requiresVisitor: true
      // description: "หน้าหลักระบบคงคลังสินค้า"
    }
  },
  //errir 404
  {
    path: "/:catchAll(.*)",
    // name: 'NotFound',
    component: NotFound,
    meta: {
      title: "ไม่พบหน้านี้",
      description: "หน้าหลักระบบคงคลังสินค้า"
    }
  },
  {
    path: "/notfound",
    name: 'NotFound',
    component: NotFound,
    meta: {
      title: "ไม่พบหน้านี้",
      description: "หน้าหลักระบบคงคลังสินค้า"
    }
  },

  /** backend route */
  {
    path: '/dashboard',
    component: BackendLayout,
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: require('@/views/backend/Dashboard.vue').default,
        beforeEnter: authGuard
      }
    ],
    meta: {
      title: "Dashboard",
      description: "หน้าหลัก",
      roles: ['$2y$10$qeKVPAufM9D/Q6S4iiOTnut9s9I6XWmHTiVAmbUfztcDg6/ddjVjm']//admin
    }
  },

  {
    path: '/dashboard',
    component: BackendLayout,
    children: [
      {
        path: 'project-Category',
        name: 'ProjectCategory',
        component: require('@/views/backend/project/Category').default,
        beforeEnter: authGuard
      }
    ],
    meta: {
      title: 'หมวดหมู่โครงการ',
      roles: ['$2y$10$qeKVPAufM9D/Q6S4iiOTnut9s9I6XWmHTiVAmbUfztcDg6/ddjVjm'],//admin
      isBackend: true,
    }
  },

  //user management
  //role
  {
    path: '/dashboard',
    component: BackendLayout,
    children: [
      {
        path: 'role',
        name: 'Role',
        component: require('@/views/backend/userManagement/Role').default,
        beforeEnter: authGuard,
      }
    ],
    meta: {
      title: 'บทบาท',
      roles: ['$2y$10$qeKVPAufM9D/Q6S4iiOTnut9s9I6XWmHTiVAmbUfztcDg6/ddjVjm']//admin
    }
  },
  //permission
  {
    path: '/dashboard',
    component: BackendLayout,
    children: [
      {
        path: 'permission',
        name: 'Permission',
        component: require('@/views/backend/userManagement/Permission').default,
        beforeEnter: authGuard,
      }
    ],
    meta: {
      title: 'สิทธิ์',
      roles: ['$2y$10$qeKVPAufM9D/Q6S4iiOTnut9s9I6XWmHTiVAmbUfztcDg6/ddjVjm']//admin
    }
  },
  //member
  {
    path: '/dashboard',
    component: BackendLayout,
    children: [
      {
        path: 'member',
        name: 'Member',
        component: require('@/views/backend/userManagement/Member').default,
        beforeEnter: authGuard
      }
    ],
    meta: {
      title: 'สมาชิก',
      roles: ['$2y$10$qeKVPAufM9D/Q6S4iiOTnut9s9I6XWmHTiVAmbUfztcDg6/ddjVjm']//admin
    }
  },
  {
    path: '/dashboard',
    component: BackendLayout,
    children: [
      {
        path: 'memberRole/:id',
        name: 'MemberRole',
        component: require('@/views/backend/userManagement/MemberRole').default,
        beforeEnter: authGuard
      }
    ],
    meta: {
      title: 'สมาชิก',
      roles: ['$2y$10$qeKVPAufM9D/Q6S4iiOTnut9s9I6XWmHTiVAmbUfztcDg6/ddjVjm']//admin
    }
  },
  //donate management จัดการการบริจาค
  {
    path: '/dashboard',
    component: BackendLayout,
    children: [
      {
        path: 'projectDonationDetail/:project_id',
        name: 'ProjectDonationDetail',
        component: require('@/views/backend/donate/management/ProjectDonationDetail').default,
        beforeEnter: authGuard
      },
    ],
    meta: {
      title: 'รายละเอียดการบริจาคของโครงการ',
      // roles: ['$2y$10$9qbDPyh9nv.zNSuj1kwKuOVcOTMUyU9vKqfMac9Xi8rlxFoMgv5I.'],//finacial officer
      isBackend: true
    },
  },
  {
    path: '/dashboard',
    component: BackendLayout,
    children: [
      {
        path: 'projectDonation',
        name: 'ProjectDonation',
        component: require('@/views/backend/donate/management/ProjectDonation').default,
        beforeEnter: authGuard
      }
    ],
    meta: {
      title: 'การบริจาคของโครงการ',
      // roles: ['$2y$10$9qbDPyh9nv.zNSuj1kwKuOVcOTMUyU9vKqfMac9Xi8rlxFoMgv5I.'],//finacial officer
      isBackend: true
    }
  },
  {
    path: '/dashboard',
    component: BackendLayout,
    children: [
      {
        path: 'donateManagement',
        name: 'DonateManagement',
        component: require('@/views/backend/donate/management/Main').default,
        beforeEnter: authGuard
      }
    ],
    meta: {
      title: 'จัดการการบริจาค',
      // roles: ['$2y$10$9qbDPyh9nv.zNSuj1kwKuOVcOTMUyU9vKqfMac9Xi8rlxFoMgv5I.'],//finacial officer
      isBackend: true
    }
  },
  {
    path: '/dashboard',
    component: BackendLayout,
    children: [
      {
        path: 'dermaIncome',
        name: 'DermaIncome',
        component: require('@/views/backend/donate/transaction/Main').default,
        beforeEnter: authGuard
      }
    ],
    meta: {
      title: 'ตรวจสอบการบริจาค',
      // roles: ['$2y$10$qeKVPAufM9D/Q6S4iiOTnut9s9I6XWmHTiVAmbUfztcDg6/ddjVjm'],//admin
      isBackend: true
    }
  },
  //roleHasPermission
  {
    path: '/dashboard',
    component: BackendLayout,
    children: [
      {
        path: 'roleHasPermission/:id',
        name: 'RoleHasPermission',
        component: require('@/views/backend/userManagement/RoleHasPermission').default,
        // props: true,
        beforeEnter: authGuard
      }
    ],
    meta: {
      title: 'จัดการบทบาท',
      roles: ['$2y$10$qeKVPAufM9D/Q6S4iiOTnut9s9I6XWmHTiVAmbUfztcDg6/ddjVjm'],//admin
      isBackend: true,
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters['authMember/logedIn']) {
      router.push({
        name: 'Login' //ถ้าไม่มีสิทธ์ให้แสดงว่าไม่พบหน้าที่ต้องการ
      })
    } else {
      next()
    }
  } else if (to.matched.some(record => record.meta.requiresVisitor)) {
    if (store.getters['authMember/logedIn']) {
      router.push({
        name: 'Riba'//ถ้าไม่มีสิทธ์ให้แสดงว่าไม่พบหน้าที่ต้องการ
      })
    } else {
      next()
    }
  } else {
    next()
  }

  if (to.meta.isBackend == true) {
    let myCart = Cookies.get('cart_items')
    if (myCart != undefined) {
      store.dispatch('authMember/retreiveCartWithoutLogin', JSON.parse(myCart))
    } else {
      store.dispatch('authMember/retreiveCartWithoutLogin', [])
    }
  } else {
    if (store.getters['authMember/logedIn']) {
      store.dispatch('authMember/retreiveCart')
    } else {
      let myCart = Cookies.get('cart_items')
      if (myCart != undefined) {
        store.dispatch('authMember/retreiveCartWithoutLogin', JSON.parse(myCart))
      } else {
        store.dispatch('authMember/retreiveCartWithoutLogin', [])
      }
    }
  }
})
export default router
